<div *ngIf="advancedSettings; else advancedSettingsNotLoaded" class="advanced-settings-container">
    <mat-form-field class="form-field">
        <mat-label>{{regionLabel}}</mat-label>
        <mat-select [(ngModel)]="currentRegionId" (ngModelChange)="regionChange($event)">
            <mat-option class="select-without-checkbox" *ngFor="let region of evaluationService.regions"
                [value]="region.id">
                {{region.name}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field class="form-field">
        <mat-label>{{transportModeLabel}}</mat-label>
        <mat-select [(ngModel)]="currentTransportModeId" (ngModelChange)="transportModeChange($event)">
            <mat-option class="select-without-checkbox" *ngFor="let transportMode of evaluationService.transportModes"
                [value]="transportMode.id">
                {{transportMode.name}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-checkbox *ngIf="showFeatureReservationNeeded" [ngModel]="advancedSettings.reservationNeeded"
        (ngModelChange)="reservationStateChange($event)" [disabled]="isReservationDisabled" class="form-field">
        {{checkBoxSeatReservation}}
    </mat-checkbox>
    <mat-form-field class="form-field">
        <mat-label>{{comfortLabel}}</mat-label>
        <mat-select [(ngModel)]="advancedSettings.comfortTypeId">
            <mat-option class="select-without-checkbox" *ngFor="let comfort of evaluationService.comfortValues"
                [value]="comfort.id">
                {{comfort.name}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="form-field">
        <mat-label>{{seatOccupancyRate}}</mat-label>
        <input matInput min="1" step="1" autoComplete="off" type="number"
            [(ngModel)]="advancedSettings.default.seatOccupancyRateDefault">
    </mat-form-field>
    <mat-form-field appearance="outline" class="form-field">
        <mat-label>{{standingplaceOccupancyRate}}</mat-label>
        <input matInput min="1" step="1" autoComplete="off" type="number"
            [(ngModel)]="advancedSettings.default.standingOccupancyRateDefault">
    </mat-form-field>
    <div class="form-field">
        <mat-form-field appearance="outline" class="m-r-15">
            <mat-label>{{personsBoarding}}</mat-label>
            <input matInput autoComplete="off" type="number" step="1" (keypress)="onKeyFunc($event)" [min]="1"
                [max]="advancedSettings.default.personValueFormatId === 1 ? 100 : null"
                [(ngModel)]="advancedSettings.default.personsBoardingDefault">
        </mat-form-field>
        <mat-form-field appearance="outline" class="m-r-15">
            <mat-label>{{personsDeboarding}}</mat-label>
            <input matInput autoComplete="off" type="number" step="1" (keypress)="onKeyFunc($event)" [min]="1"
                [max]="advancedSettings.default.personValueFormatId === 1 ? 100 : null"
                [(ngModel)]="advancedSettings.default.personsDeboardingDefault">
        </mat-form-field>
        <span>
            <mat-radio-group aria-labelledby="example-radio-group-label"
                [(ngModel)]="advancedSettings.default.personValueFormatId">
                <mat-radio-button class="example-radio-button" [value]="1">
                    {{percent}}
                </mat-radio-button>
                <mat-radio-button class="example-radio-button" [value]="2">
                    {{absolute}}
                </mat-radio-button>
            </mat-radio-group>
        </span>
    </div>
    <mat-form-field appearance="outline" class="form-field">
        <mat-label>{{personsPerSquareMeterEntranceArea}}</mat-label>
        <input matInput autoComplete="off" type="number" min="0" max="8"
            [(ngModel)]="advancedSettings.default.personsPerSquareMeterEntranceArea">
    </mat-form-field>
    <mat-form-field appearance="outline" class="form-field">
        <mat-label>{{personsPerSquareMeterMultiPurposeArea}}</mat-label>
        <input matInput autoComplete="off" type="number" min="0" max="8"
            [(ngModel)]="advancedSettings.default.personsPerSquareMeterMultiPurposeArea">
    </mat-form-field>
    <mat-form-field appearance="outline" class="form-field">
        <mat-label>{{personsPerSquareMeterAisle}}</mat-label>
        <input matInput autoComplete="off" type="number" min="0" max="8"
            [(ngModel)]="advancedSettings.default.personsPerSquareMeterAisle">
    </mat-form-field>
    <div class="flex-container space-between">
        <button mat-raised-button class="button color" title="{{btnResetRegionDefaultsTitel}}"
            (click)="resetToRegionDefaults()">{{btnResetRegionDefaults}}</button>
        <button mat-raised-button class="button color" title="{{btnResetProjectDefaultsTitel}}"
            (click)="resetToProjectDefaults()">{{btnResetProjectDefaults}}</button>
        <button mat-raised-button class="button color" title="{{btnSaveProjectDefaultsTitel}}"
            (click)="saveAsProjectDefaultDialog()">{{btnSaveProjectDefaults}}</button>
        <button mat-raised-button class="button color" (click)="openAgeGenderMatrix()">Age
            Gender Distribution</button>
    </div>
</div>
<ng-template #advancedSettingsNotLoaded>
    <p>Please select a project first to see this content</p>
</ng-template>